import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';
import { LetDirective } from 'src/app/core/utils/let-directive';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { TAIGA_UI_MODULES } from 'src/app/shared/taiga.module';
import { SharedModule } from '../../shared/shared.module';
import { AngularMaterialModule } from '../angular-material.module';
import { AccessRestrictedComponent } from './components/access-restricted/access-restricted.component';
import { AccessRestrictedRoutingModule } from './access-restricted-routing.module';

@NgModule({
  declarations: [AccessRestrictedComponent],
  imports: [
    AccessRestrictedRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    CommonModule,
    AngularMaterialModule,
    MatIconModule,
    TranslocoModule,
    PipesModule,
    LetDirective,
    TAIGA_UI_MODULES,
  ],
})
export class AccessRestrictedModule {}
